import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt, faChartBar, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/student-actions.module.scss';
import { IStudent } from 'src/types/student';
import DeleteStudentAction from './DeleteStudentAction';
import user from 'src/services/user-auth';

const StudentActionsColumn: React.FunctionComponent<CellProps<IStudent>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IStudent>) => {
    const userRole: Array<string> = user.getRoles();
    return (
        <div className={classNames(styles.actions)}>
            <Link
                key={original.id + 'chart'}
                className={'btn btn-light'}
                to={Router.generate(routes.STUDENT_DETAIL, { id: original.id, tab: 'program-book' })}
            >
                <FontAwesomeIcon icon={faChartBar} />
            </Link>
            {original?.programBooks?.length && original.programBooks[0]?.id ? (
                <Link
                    key={original.id + 'pbook'}
                    className={'btn btn-light'}
                    to={Router.generate(routes.PROGRAM_BOOK_EDIT, { id: original.programBooks[0]?.id })}
                >
                    <FontAwesomeIcon icon={faBookOpen} />
                </Link>
            ) : (
                <Link
                    key={original.id + 'pbook'}
                    className={'btn btn-light'}
                    to={Router.generate(routes.PROGRAM_BOOK_CREATE, { id: original.id })}
                >
                    <FontAwesomeIcon icon={faBookOpen} />
                </Link>
            )}
            {userRole.map((i: string) =>
                i === 'ROLE_ADMIN' ? (
                    <>
                        <Link className={'btn btn-info'} to={Router.generate(routes.STUDENT_EDIT, { id: original.id })}>
                            <FontAwesomeIcon icon={faPencilAlt} />
                        </Link>
                        <DeleteStudentAction data={original} />
                    </>
                ) : null,
            )}
        </div>
    );
};

export default StudentActionsColumn;
